import { Component, OnInit, inject, effect } from '@angular/core';
import {
  RouterOutlet,
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { filter } from 'rxjs';
import { LocalStorageService } from './shared/services/local-storage/local-storage.service';
import { NotificationService } from './shared/services/notification/notification.service';
import { LoaderService, LOADER_BODY } from './shared/services/loader/loader.service';
import { AuthService } from './shared/services/auth/auth.service';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, ProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'otithiweb';
  loaderService = inject(LoaderService);
  authService = inject(AuthService);
  private currentPath = '';

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly notificationService: NotificationService,
    private readonly router: Router
  ) {
    // Show body loader when permissions are loading (sidebar/nav stay fixed)
    effect(() => {
      const loading = this.authService.isLoading();
      if (loading) {
        this.loaderService.show(LOADER_BODY, 'Loading page...');
      } else {
        setTimeout(() => {
          this.loaderService.hide(LOADER_BODY);
        }, 100);
      }
    });
  }

  ngOnInit(): void {
    if (
      !this.localStorageService.getIsNotificationRegistered() &&
      this.localStorageService.getToken()
    ) {
      this.notificationService.requestPermissionToNotificationServer();
    }

    // Show body loader only when path changes (sidebar/nav stay fixed; only content area loads with animation)
    this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationStart ||
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          const path = (event.url || '').split('?')[0].split('#')[0];
          if (path !== this.currentPath) {
            this.loaderService.show(LOADER_BODY, 'Loading page...');
          }
        } else {
          this.currentPath = this.router.url.split('?')[0].split('#')[0];
          setTimeout(() => {
            this.loaderService.hide(LOADER_BODY);
          }, 100);
        }
      });
  }
}
